import gql from 'graphql-tag'
import { DealFragment } from '@/graphql/fragments/crm'

export const query = gql`
  ${DealFragment}
  query findLiteDeal($filter: crm_deal_bool_exp) {
    records: crm_deal(where: $filter) {
      ...Deal
      saleOrders: sale_orders {
        id
      }
      stock{
        id
      }
    }
  }
`

export default query
